export const zambiaProvinces = {
    Central: {
      districts: {
        Kabwe: ["Bwacha", "Kabwe Central"],
        KapiriMposhi: ["Kapiri Mposhi"],
        Chibombo: ["Katuba", "Keembe", "Chisamba"],
        Mkushi: ["Mkushi South", "Mkushi North"],
        Serenje: ["Muchinga", "Serenje"],
        Mumbwa: ["Mumbwa", "Nangoma"],
        Ngabwe: ["Ngabwe"],
        Chisamba: ["Chisamba"],
      },
    },
    Copperbelt: {
      districts: {
        Ndola: ["Chifubu", "Kabushi", "Ndola Central", "Bwana Mkubwa"],
        Kitwe: ["Nkana", "Wusakile", "Kamfinsa", "Kwacha", "Chimwemwe"],
        Luanshya: ["Roan", "Luanshya"],
        Chingola: ["Chingola", "Nchanga"],
        Mufulira: ["Mufulira", "Kantanshi"],
        Kalulushi: ["Kalulushi", "Lufwanyama"],
        Chililabombwe: ["Chililabombwe"],
        Masaiti: ["Masaiti"],
        Mpongwe: ["Mpongwe"],
        Lufwanyama: ["Lufwanyama"],
      },
    },
    Eastern: {
      districts: {
        Chipata: ["Chipangali", "Chipata Central", "Kasenengwa"],
        Katete: ["Katete"],
        Sinda: ["Sinda"],
        Petauke: ["Petauke Central", "Nyimba"],
        Lundazi: ["Lumezi", "Chasefu"],
        Mambwe: ["Mambwe"],
        Vubwi: ["Vubwi"],
      },
    },
    Luapula: {
      districts: {
        Mansa: ["Mansa Central", "Chembe"],
        Samfya: ["Bangweulu"],
        Mwense: ["Mwense"],
        Kawambwa: ["Kawambwa"],
        Nchelenge: ["Chiengi"],
        Milenge: ["Milenge"],
        Chienge: ["Chienge"],
        Lunga: ["Lunga"],
        Chipili: ["Chipili"],
      },
    },
    Lusaka: {
      districts: {
        Lusaka: [
          "Matero",
          "Mandevu",
          "Munali",
          "Lusaka Central",
          "Kabwata",
          "Chawama",
          "Kanyama",
        ],
        Chilanga: ["Chilanga"],
        Kafue: ["Kafue"],
        Chongwe: ["Chongwe"],
        Rufunsa: ["Rufunsa"],
      },
    },
    Muchinga: {
      districts: {
        Chinsali: ["Chinsali", "Lubu"],
        Nakonde: ["Nakonde"],
        Isoka: ["Isoka"],
        Mpika: ["Mpika"],
        Mafinga: ["Mafinga"],
        Shiwangandu: ["Shiwangandu"],
        Kanchibiya: ["Kanchibiya"],
      },
    },
    Northern: {
      districts: {
        Kasama: ["Kasama Central", "Lupososhi"],
        Mbala: ["Mbala"],
        Luwingu: ["Luwingu"],
        Kaputa: ["Kaputa"],
        Chilubi: ["Chilubi"],
        Mungwi: ["Mungwi"],
        Mpulungu: ["Mpulungu"],
        Nsama: ["Nsama"],
      },
    },
    NorthWestern: {
      districts: {
        Solwezi: ["Solwezi Central", "Kalumbila"],
        Kasempa: ["Kasempa"],
        Mwinilunga: ["Mwinilunga"],
        Zambezi: ["Zambezi East", "Zambezi West"],
        Kabompo: ["Kabompo"],
        Manyinga: ["Manyinga"],
        Chavuma: ["Chavuma"],
      },
    },
    Southern: {
      districts: {
        Livingstone: ["Livingstone"],
        Mazabuka: ["Mazabuka Central", "Magoye"],
        Monze: ["Monze Central", "Bweengwa"],
        Choma: ["Choma Central", "Pemba"],
        Kalomo: ["Kalomo Central"],
        Namwala: ["Namwala"],
        Gwembe: ["Gwembe"],
        Siavonga: ["Siavonga"],
        Sinazongwe: ["Sinazongwe"],
        Kazungula: ["Kazungula"],
        ItezhiTezhi: ["Itezhi Tezhi"],
      },
    },
    Western: {
      districts: {
        Mongu: ["Mongu Central"],
        Sesheke: ["Sesheke"],
        Kalabo: ["Kalabo"],
        Kaoma: ["Kaoma", "Mangango"],
        Senanga: ["Senanga"],
        Shangombo: ["Shangombo"],
        Lukulu: ["Lukulu"],
        Nalolo: ["Nalolo"],
        Mwandi: ["Mwandi"],
        Sioma: ["Sioma"],
      },
    },
  };
  